import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {VisualParticipantModel} from '../../../models/api/visualParticipantModel';
import {focusCalendarEventAction} from '../../../store/panels/calendars/calendarsPanelActions';
import {
  buildCalendarEventParametersFromData,
  CalendarEventData,
} from '../../../store/panels/calendars/calendarsPanelSelectors';
import {CalendarsPanelId} from '../../../store/panels/panelStateBase';
import {PopoverCalendarEventViewerHeader} from './popoverCalendarEventViewerHeader';

/*
 * Props.
 */

interface PopoverCalendarEventViewerHeaderContainerProps {
  panelId: CalendarsPanelId;
  calendarEventData: CalendarEventData;
  visualParticipants: ReadonlyArray<VisualParticipantModel>;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<PopoverCalendarEventViewerHeaderContainerProps>()(
  (props) => ({
    onEditClick: () => {
      const eventParameters = buildCalendarEventParametersFromData(props.calendarEventData);
      return focusCalendarEventAction(props.panelId, eventParameters);
    },
  }),
);

export const PopoverCalendarEventViewerHeaderContainer = connect(
  null,
  mapDispatchToProps,
)(PopoverCalendarEventViewerHeader);
